// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { PropTypes } from 'react';

// utilities
import { isNil, chunk } from 'lodash';
import cx from 'classnames';
import localDate from '../../../../../lib/localDate';
import emailLink from '../../../../../lib/emailLink';
import prettyPhone from '../../../../../lib/prettyPhone';
import prettyTimezone from '../../../../../lib/prettyTimezone';
import CloseX from '../../../../../common/svgs/CloseX';

function ApplicantCard(props) {
  const {
    applicant,
    selectedEmail,
    corkBoard,
    togglePin,
  } = props;

  // this will be a prop
  const transparentPct = isNil(applicant.lifespan) ? 1 : ((applicant.lifespan > 0) ? 1 - ((+new Date() - +new Date(applicant.profile.dateModifiedByApplicant||applicant.profile.dateCreated))/(applicant.lifespan * 60 * 60 * 1000)) : 0);
  const rgbaColor = `rgba(${
    chunk(applicant.color.slice(1), 2).map(stringArr => Number.parseInt(stringArr.join(''), 16)).join() // conversion from base 16
  },${transparentPct})`; // calculating opacity

  return (
    <div
        id={applicant.user.email}
        data-id={applicant.user.email}
        className={cx('applicant-card', {transparent: selectedEmail === applicant.user.email})}>
      <div className='status-container'>
        <div className='status-circle' data-id='Status Icon'
          onClick={props.expandCard.bind(this, applicant.profile.id, true)}
          style={{backgroundColor: rgbaColor, borderColor: applicant.color, color: transparentPct < 0.25 ? applicant.color : '#fff'}}>{applicant.label || ''}</div>
        <div className='expand-icon' onClick={props.expandCard.bind(this, applicant.profile.id)} />
      </div>
      <div className='applicant-info' onClick={props.expandCard.bind(this, applicant.profile.id, true)}>
        <div className='applicant-info-primary'>
          <div className='applicant-name' data-id='Name'>
            {`${applicant.user.firstName} ${applicant.user.lastName}`}
          </div>
          <div className='applicant-email' data-id='Email'>
            {emailLink(applicant.user.email)}
          </div>
          <div className='applicant-phone' data-id='Phone Number'>
            {prettyPhone(applicant.user.phoneNumber1)}
          </div>
          <div className='applicant-best-contact-time' data-id='best contact time'>
            {applicant.bestContactTime}
          </div>
        </div>
      </div>
      <div className='applicant-info' onClick={props.expandCard.bind(this, applicant.profile.id, true)}>
        <div className='applicant-info-secondary'>
          <div className='applicant-timezone' data-id='timezone'>
            {prettyTimezone(applicant.timezone)}&nbsp;
          </div>
          {
            applicant.profile.followUpDate
            &&
            <div className='applicant-followup' data-id='followup'>
              Follow Up: {localDate(applicant.profile.followUpDate)}
            </div>
          }
          {
            applicant.profile.availabilityDate
            &&
            <div className='applicant-updated' data-id='updated'>
              Availability: {localDate(applicant.profile.availabilityDate)}
            </div>
          }
          <div className='applicant-applied' data-id='applied'>
            Applied: {localDate(applicant.profile.dateCreated)}
          </div>
        </div>
      </div>
      {
        corkBoard
        &&
        <div className='applicant-close'
          data-id='close-icon'
          onClick={togglePin.bind(this, applicant)}
        >
          <div className='closeIcon'><CloseX /></div>
        </div>
      }
    </div>
  );
}

ApplicantCard.propTypes = {
  expandCard: PropTypes.func,
  applicant: PropTypes.object.isRequired,
  selectedEmail: PropTypes.string
};


export default ApplicantCard;



// WEBPACK FOOTER //
// ./shared/react/r_AdminDashboard/r_ApplicantManager/c_ApplicantsColumn/f_ApplicantCard/index.js